import React from "react";
import "./AttachFilesAICard.scss";
import aiChatlogo from "../../../../../../assets/Images/aiChatlogo.png";

// Card component for displaying attach files instructions
export const AttachFilesAICard = ({ message }) => {
    const headerTitle = message?.header?.title || "GDS.ai Axon";

    // Parse the text into sections
    const parseContent = (text) => {
        if (!text) return { intro: "", fileTypes: [], beforeAttach: [], beforeAttachItems: [], outro: "" };

        const lines = text.split("\n").filter(Boolean);
        const fileTypes = [];
        const beforeAttachItems = [];
        let intro = "";
        let outro = "";
        let currentSection = "intro";

        lines.forEach((line) => {
            const trimmedLine = line.trim();

            if (trimmedLine.startsWith("▸ Journal Entry") ||
                trimmedLine.startsWith("▸ Trial Balance") ||
                trimmedLine.startsWith("▸ Chart of Account") ||
                trimmedLine.startsWith("▸ Others")) {
                currentSection = "fileTypes";
                // Parse file type with mandatory/recommended tag
                const isMandatory = trimmedLine.includes("(Mandatory)");
                const isRecommended = trimmedLine.includes("(Recommended)");
                const label = trimmedLine.replace("▸ ", "").replace("(Mandatory)", "").replace("(Recommended)", "").trim();
                fileTypes.push({
                    label,
                    tag: isMandatory ? "Mandatory" : isRecommended ? "Recommended" : "",
                    tagClass: isMandatory ? "mandatory" : "recommended"
                });
            } else if (trimmedLine === "Before you attach..") {
                currentSection = "beforeAttach";
            } else if (currentSection === "beforeAttach" && trimmedLine.startsWith("▸")) {
                beforeAttachItems.push(trimmedLine.replace("▸ ", ""));
            } else if (trimmedLine.startsWith("Once you're done")) {
                currentSection = "outro";
                outro = trimmedLine;
            } else if (currentSection === "intro" && !trimmedLine.startsWith("▸")) {
                intro = trimmedLine;
            }
        });

        return { intro, fileTypes, beforeAttachItems, outro };
    };

    const content = parseContent(message?.text);
    const statusParagraphs = message?.statusParagraphs;

    return (
        <div className="attach-files-ai-card">
            <div className="attach-files-ai-card-header">
                <div className="attach-files-ai-card-avatar">
                    <img src={aiChatlogo} alt="GDS.ai Axon" />

                </div>
                <span className="attach-files-ai-card-title">{headerTitle}</span>
                <span className="attach-files-ai-card-time">Just Now</span>
            </div>

            <div className="attach-files-ai-card-content">
                {Array.isArray(statusParagraphs) ? (
                    statusParagraphs.map((paragraph) => (
                        <p key={paragraph} className="attach-files-intro">{paragraph}</p>
                    ))
                ) : (
                <>
                {content.intro && (
                    <p className="attach-files-intro">{content.intro}</p>
                )}

                {content.fileTypes.length > 0 && (
                    <ul className="attach-files-list">
                        {content.fileTypes.map((item, index) => (
                            <li key={index} className="attach-files-list-item">
                                <span className="attach-files-list-icon">▸</span>
                                <span className="attach-files-list-label">{item.label}</span>
                                {item.tag && (
                                    <span className={`attach-files-tag ${item.tagClass}`}>
                                        ({item.tag})
                                    </span>
                                )}
                            </li>
                        ))}
                    </ul>
                )}

                {content.beforeAttachItems.length > 0 && (
                    <>
                        <p className="attach-files-section-title">Before you attach..</p>
                        <ul className="attach-files-list">
                            {content.beforeAttachItems.map((item, index) => (
                                <li key={index} className="attach-files-list-item">
                                    <span className="attach-files-list-icon">▸</span>
                                    <span className="attach-files-list-label">{item}</span>
                                </li>
                            ))}
                        </ul>
                    </>
                )}

                {content.outro && (
                    <p className="attach-files-outro">{content.outro}</p>
                )}
                </>
                )}
            </div>
        </div>
    );
};
